export { AeraButton } from "./AeraButton";
export type {
  AeraButtonProps,
  AeraButtonVariant,
  AeraButtonSize,
  AeraButtonTextSize,
  AeraButtonPaddingSize,
  AeraButtonTextColor,
  AeraButtonFontWeight,
} from "./AeraButton";

export { default as Modal } from "./Modal";
export type { ModalProps, ModalSize, ModalPlacement } from "./Modal";
export {
  ModalBody,
  ModalBodyContent,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  MODAL_HEADER_CLASSNAME,
} from "./ModalParts";
export type {
  ModalCloseButtonProps,
  ModalHeaderProps,
  ModalBodyProps,
  ModalBodyContentProps,
  ModalFooterProps,
} from "./ModalParts";

export { ModalShell } from "./ModalShell";
export type { ModalShellProps, ModalAlign } from "./ModalShell";

export {
  MODAL_PANEL_ANIMATION_MS,
  MODAL_SHEET_ANIMATION_MS,
  modalOverlayMotion,
  modalPanelMotion,
  modalSheetOverlayMotion,
  modalSheetPanelMotion,
  modalDrawerPanelMotion,
  modalResponsiveDrawerPanelMotion,
  modalCenteredPopoverMotion,
} from "./modalMotion";
export type { ModalMotionPhase } from "./modalMotion";

export { useModalPresence } from "./useModalPresence";

export { CardScrollRail, ScrollRailNavButtons } from "./CardScrollRail";
export type {
  CardScrollRailProps,
  ScrollRailNavButtonsProps,
} from "./CardScrollRail";

export { useHorizontalScrollRail } from "./useHorizontalScrollRail";
export type {
  HorizontalScrollHints,
  UseHorizontalScrollRailOptions,
} from "./useHorizontalScrollRail";

export { SegmentedTabSwitcher } from "./SegmentedTabSwitcher";
export type {
  SegmentedTabItem,
  SegmentedTabSwitcherProps,
} from "./SegmentedTabSwitcher";
